import { render, staticRenderFns } from "./DownloadIcon.vue?vue&type=template&id=661c16c0&inline"
import script from "./DownloadIcon.vue?vue&type=script&lang=js&inline"
export * from "./DownloadIcon.vue?vue&type=script&lang=js&inline"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports